import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type EnableWorkspaceNotificationsMutationVariables = Types.Exact<{
  input: Types.ToggleWorkspaceNotificationsInput;
}>;


export type EnableWorkspaceNotificationsMutation = { __typename?: 'Mutation', enableWorkspaceNotifications?: { __typename?: 'ToggleWorkspaceNotificationsPayload', workspace?: { __typename?: 'Workspace', id: string, projectNotificationsEnabled?: boolean | null } | null } | null };


export const EnableWorkspaceNotifications = /*#__PURE__*/ gql`
    mutation EnableWorkspaceNotifications($input: ToggleWorkspaceNotificationsInput!) {
  enableWorkspaceNotifications(input: $input) {
    workspace {
      id
      projectNotificationsEnabled
    }
  }
}
    ` as unknown as DocumentNode<EnableWorkspaceNotificationsMutation, EnableWorkspaceNotificationsMutationVariables>;

          

          export const useEnableWorkspaceNotificationsMutation = (options?:MutationHookOptions<EnableWorkspaceNotificationsMutation, EnableWorkspaceNotificationsMutationVariables>) => useMutation(EnableWorkspaceNotifications, options);
          

          export type EnableWorkspaceNotificationsMutationOptions = MutationHookOptions<EnableWorkspaceNotificationsMutation, EnableWorkspaceNotificationsMutationVariables>;

          

          export type EnableWorkspaceNotificationsMutationResult = ReturnType<typeof useEnableWorkspaceNotificationsMutation>[1];

          
